export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/like/icon-like-light-d3d3d9f4fbbe82d4fb6c20d9cd888623.svg";